import React from 'react';
import PropTypes from 'prop-types';

function CopiedToastMessage({ message }) {
  return (
    <div className="full-text-success-toast-message__content">
      <span className="full-text-success-toast-message__content_icon ">
        <svg className="els-btn-icon">
          <use xlinkHref="#icon-check" />
        </svg>
      </span>
      {message}
    </div>
  );
}

CopiedToastMessage.defaultProps = {
  message: 'Copied',
};

CopiedToastMessage.propTypes = {
  message: PropTypes.string,
};

export default CopiedToastMessage;
